import * as Config from '../../../config';
import ReactDOM from 'react-dom';
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import ChevronLeft from '../svg/ChevronLeft'

function PrevGridPortal({ rootID = null, onClick, style }) {
  const [root, setRoot] = useState(null)
  useEffect(() => {
    setTimeout(() => {
      setRoot(document.getElementsByClassName(rootID)[0]);
    }, 500)
  }, [rootID])

  if (root && rootID) {
    let el = document.createElement('div');
    root.appendChild(el);

    return ReactDOM.createPortal((
      <div onClick={onClick} className={`pag-chevron-v2 left flexColumn f-center`}>
        <ChevronLeft color={ Config.TYPE_PLACEHOLDER } style={style} />
      </div>
    ), el);
  } else {
    return null
  }
}

PrevGridPortal.propTypes = {
  onClick: PropTypes.func,
  rootID: PropTypes.any,
  style: PropTypes.object
}

export default PrevGridPortal;
